import {Button} from "react-bootstrap";
import React from "react";

interface IProps {
    onClick?: () => void;
    caption?: string;
    extraClass?: string;
    styleClass?: string;
    iconClass?: string;
    id?: string;
    disabled?: boolean;
}

export const ListViewToolbarButton = ({
                                          onClick,
                                          disabled,
                                          id,
                                          caption,
                                          extraClass,
                                          iconClass,
                                          styleClass = "btn-light"
                                      }: IProps) => {
    return (
        <>
            <Button
                disabled={disabled}
                id={id}
                size={"sm"}
                variant=""
                className={`btn ${styleClass} ${extraClass}`}
                onClick={onClick}
            >
                {iconClass && <i className={`${iconClass} me-2`}></i>}
                {caption}
            </Button>
        </>
    )
}